import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';
import './styles/scrollbar.css';
import { useUserContext } from './contexts/UserContext';
import AppHeader from './components/AppHeader';
import AppSidebar from './components/AppSidebar';
import LoginPage from './components/LoginPage';
import Lazywa from './components/lazywa/Lazywa';
import Scheduler from './components/lazywa/Scheduler';
import ChatAdvice from './components/lazywa/ChatAdvice';
import AdvisorChatPage from './components/lazywa/AdvisorChatPage';
import { auth, provider, signInWithPopup } from './firebase';
import axiosInstance from './utils/axiosInstance'; // Import your axios instance

const App = () => {
    const [activeMenuItem, setActiveMenuItem] = useState('dashboard');
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const { user, setUser } = useUserContext();
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleLogin = (userData) => {
        const token = localStorage.getItem('token');
        if (typeof token === 'string' && token.trim() !== '') {
            setIsLoggedIn(true);
            setUser(userData);
            setShowLoginModal(false);
        } else {
            addNotification('Invalid token format', 'danger');
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUser(null);
    };

    const handleMenuSelect = (menuItem) => {
        setActiveMenuItem(menuItem);
        setIsSidebarVisible(false);
    };

    const toggleSidebar = () => {
        setIsSidebarVisible(prev => !prev);
    };

    const addNotification = (message, type) => {
        setNotifications(prevNotifications => [
            ...prevNotifications,
            { id: Date.now(), message, type }
        ]);
    };

    const removeNotification = (id) => {
        setNotifications(prevNotifications => prevNotifications.filter(notification => notification.id !== id));
    };

    return (
        <Router>
            <Container fluid className="d-flex flex-column p-0">
                {isLoggedIn ? (
                    <>
                        <AppHeader
                            isLoggedIn={isLoggedIn}
                            user={user}
                            showLoginModal={showLoginModal}
                            setShowLoginModal={setShowLoginModal}
                            handleLogout={handleLogout}
                            handleMenuSelect={handleMenuSelect}
                            notifications={notifications}
                            removeNotification={removeNotification}
                        />
                        <Row className='flex-grow-1'>
                            {isSidebarVisible && (
                                <Col xs={3} className='p-0'>
                                    <AppSidebar
                                        activeMenuItem={activeMenuItem}
                                        handleMenuSelect={handleMenuSelect}
                                        isLoggedIn={isLoggedIn}
                                    />
                                </Col>
                            )}
                            <Col xs={isSidebarVisible ? 9 : 12} className='overflow-y-scroll overflow-x-auto vh-75 pb-3'>
                                <Routes>
                                    {isLoggedIn ? (
                                        <>
                                            <Route path="/lazywa" element={<Lazywa addNotification={addNotification} />} />
                                            <Route path="/scheduler" element={<Scheduler addNotification={addNotification} />} />
                                            <Route path="/tips" element={<ChatAdvice userId={user._id} />} />
                                            <Route path="/advisor" element={<AdvisorChatPage />} />
                                            <Route path="/" element={<Navigate to="/lazywa" />} />
                                        </>
                                    ) : (
                                        <>
                                            <Route path="/login" element={<LoginPage handleLogin={handleLogin} />} />
                                            <Route path="*" element={<Navigate to="/login" />} />
                                        </>
                                    )}
                                </Routes>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <div className="container-fluid p-0 d-flex justify-content-center align-items-center vh-75">
                        <Routes>
                            <Route path="/login" element={isLoggedIn ? <Navigate to="/lazywa" /> : <LoginPage handleLogin={handleLogin} />} />
                            <Route path="*" element={<Navigate to="/login" />} />
                        </Routes>
                    </div>
                )}
            </Container>
        </Router>
    );
};

export default App;
